import { createApp, reactive, watch } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import './assets/tailwind.css'

axios.defaults.baseURL = 'https://carpatinaprodcom.ro/api'

// --- 1. LOGICA PENTRU COȘ (CERERE DE OFERTĂ) ---
// Citim ce e deja salvat, dacă există
const savedCart = JSON.parse(localStorage.getItem('carpatina_cart')) || []

// Creăm un obiect reactiv global
const globalCart = reactive({
  items: savedCart,
  
  // Adaugă produs
  add(productId, quantity = 1) {
    const existing = this.items.find(i => i.productId === productId)
    if (existing) {
      existing.quantity += quantity
    } else {
      this.items.push({ productId, quantity })
    }
  },
  
  // Modifică cantitatea
  update(productId, quantity) {
    const item = this.items.find(i => i.productId === productId)
    if (item) {
      if (quantity <= 0) {
        this.remove(productId)
      } else {
        item.quantity = quantity
      }
    }
  },
  
  // Șterge produs
  remove(productId) {
    this.items = this.items.filter(i => i.productId !== productId)
  },
  
  // Golește tot coșul (o folosești după ce trimite cererea)
  clear() {
    this.items = []
  },
  
  // Getter pentru numărul total de produse (bun pentru badge-ul de sus)
  get totalItems() {
    return this.items.reduce((sum, item) => sum + item.quantity, 0)
  }
})

// Sincronizare automată: ori de câte ori se modifică `globalCart.items`, salvăm în LocalStorage
watch(() => globalCart.items, (newVal) => {
  localStorage.setItem('carpatina_cart', JSON.stringify(newVal))
}, { deep: true })
// ------------------------------------------------


const app = createApp(App)

// Facem axios disponibil global (opțional)
app.config.globalProperties.$http = axios

// --- 2. INJECTĂM COȘUL GLOBAL ---
// Orice componentă va putea accesa `cart` fără să îl pasezi prin props
app.provide('cart', globalCart)

app.use(router)
app.mount('#app')